import { ALL_MEMBERS_ROUTE } from '@modules/conversations/features/all-members-conversation/all-members-conversation.constants';
import { useLocation } from 'react-router-dom';

export function useIsMemberChat() {
  const { pathname } = useLocation();

  return pathname.includes('/conversations/member') || pathname.includes(ALL_MEMBERS_ROUTE);
}
